import Skeleton from './Skeleton'
import useWindowSize from '../../../hooks/useWindowSize'

const CourseOutcomes = ({ outcomes }) => {

    const { width } = useWindowSize()
    
    return (
        <div className='mt-9'>
            <h2 className='text-2xl font-semibold mb-3'>With This Course, You Will Be Able To</h2>
            {outcomes?.length > 0 ? outcomes?.slice?.(0, outcomes?.length > 7 ? 7 : outcomes?.length).map((feature, index) => (
                feature?.length > 0 && feature?.length < 180 && <div key={index} className='bg-[#2D4F71] mb-2 p-3 rounded-xl flex items-center'>
                    <div className={`${width < 560 ? 'w-[8%]' : 'w-[5%]'}`}>
                        <div className='w-5 h-5'>
                            <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Check_Mark_2.png?updatedAt=1689668200966" alt="" className='h-full w-full'/>
                        </div>
                    </div>
                    <p className='ml-2 flex-1 font-medium leading-5'>{feature}</p>
                </div>
            )) : <Skeleton/>}
        </div>
    )
}

export default CourseOutcomes
